export const exportHeaders = [
    {
        label: "Member ID",
        key: "loyalty_id"
    },

    {
        label: "Billto",
        key: "customer_billto_account_number"
    },


    {
        label: "Shipto",
        key: "customer_account_number"
    },

    {
        label: "Tier Level",
        key: "plan"
    },

    {
        label: "Start Date",
        key: "service_plus_start_date"
    },

    {
        label: "End Date",
        key: "service_plus_end_date"
    },
    {
        label: "Initiated By",
        key: "altered_by"
    },
    {
        label: "Updated By",
        key: "user_name"
    }

    
]